export default __webpack_public_path__ + "static/media/ic-list-block.38bf5d2a.svg";